import {Component, OnInit} from '@angular/core';
import { Location } from '@angular/common';

export type ButtonType = 'primary' | 'secondary' | 'tertiary'

@Component({
  selector: 'edu-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {

  constructor(private _location: Location) {}

  ngOnInit(): void {}

	backClicked() {
		this._location.back();
	}

}
